import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail } from "lucide-react";
import { siteInfo, navLinks } from "../data/mock";
import { SpotifyIcon } from "./Navbar";

const Footer = () => {
  return (
    <footer className="border-t border-black/10 bg-[#f4f1ec] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <h3
            className="text-3xl tracking-tight text-black mb-3"
            style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 500 }}
          >
            Leonard RR Cox
          </h3>
          <p className="text-neutral-600 text-sm leading-relaxed max-w-sm">
            Composer and sound designer specializing in cinematic music for
            video games and film.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-4">
            Navigate
          </h4>
          <ul className="space-y-2">
            {navLinks.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-neutral-800 hover:text-black transition-colors text-[15px]"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-4">
            Connect
          </h4>
          <div className="flex items-center gap-5 text-neutral-800">
            <a
              href={siteInfo.spotifyUrl}
              target="_blank"
              rel="noreferrer"
              aria-label="Spotify"
              className="hover:text-black transition-colors"
            >
              <SpotifyIcon className="w-5 h-5" />
            </a>
            <a
              href={siteInfo.youtubeUrl}
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
              className="hover:text-black transition-colors"
            >
              <Youtube size={20} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="hover:text-black transition-colors"
            >
              <Instagram size={20} />
            </a>
            <a
              href={`mailto:${siteInfo.email}`}
              aria-label="Email"
              className="hover:text-black transition-colors"
            >
              <Mail size={20} />
            </a>
          </div>
          <p className="text-neutral-500 text-xs mt-6">
            © {new Date().getFullYear()} Leonard R.R. Cox. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
